import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { PremiumSimulatorDetailsTable } from "./DetailsTable";

export const PremiumSimulatorDetails = ({ titleKey, ...props }) => (
  <div className="resultDetails">
    <h4>
      <FormattedMessage id={titleKey} />
    </h4>
    <PremiumSimulatorDetailsTable {...props} />
  </div>
);

PremiumSimulatorDetails.propTypes = {
  titleKey: PropTypes.string,
  ...PremiumSimulatorDetailsTable.propTypes,
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/results/Details.js